import AccommodationIndividualSelectRoomTile from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomTile'
import AccommodationIndividualSelectRoomTileDetails from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomTileDetails'
import AccommodationIndividualSelectRoomOptions from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomOptions'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { rem } from 'polished'
import { useCallback, useMemo } from 'react'

import type { RoomRateViews } from './singlePropertyUtils'
import PropertyIndividualRoomSelectRoomOption from './PropertyIndividualRoomSelectRoomOption'

interface Props {
  optionVariant: 'stacked' | 'carousel'
  roomOption: RoomRateViews
  currentRoomTypeId?: string
  currentOptionId?: string
  duration: number
  noRateSelectionEnabled?: boolean
  onSelectRate: (roomTypeId: string, optionId: string) => void
}

function PropertyIndividualRoomSelectRoom(props: Props) {
  const {
    optionVariant,
    roomOption,
    currentRoomTypeId,
    currentOptionId,
    duration,
    noRateSelectionEnabled = false,
    onSelectRate,
  } = props

  const isCurrentSelection = roomOption.roomId === currentRoomTypeId
  const carouselWidth = roomOption.rates.length > 1 ? rem(300) : '100%'

  const sortedRates = useMemo(() => {
    return [...roomOption.rates].sort((left, right) => left.totals.displayPrice - right.totals.displayPrice)
  }, [roomOption.rates])

  const isRateSelected = useCallback((rate: App.EnrichedPropertyRate): boolean => {
    return rate.optionId === currentOptionId
  }, [currentOptionId])

  const optionTiles = sortedRates.map((rate) => (
    <PropertyIndividualRoomSelectRoomOption
      key={rate.optionId}
      propertyRoom={roomOption.propertyRoom}
      rate={rate}
      isSelected={isCurrentSelection && isRateSelected(rate)}
      optionVariant={optionVariant}
      duration={duration}
      onSelect={(optionId) => onSelectRate(roomOption.roomId, optionId)}
    />
  ))

  const noRateOption = <PropertyIndividualRoomSelectRoomOption
    propertyRoom={roomOption.propertyRoom}
    rate={undefined}
    isSelected={isCurrentSelection}
    optionVariant={optionVariant}
    duration={duration}
    onSelect={() => onSelectRate(roomOption.roomId, currentOptionId ?? '')}
  />

  return (
    <AccommodationIndividualSelectRoomTile roomPackage={roomOption.propertyRoom} isCurrentSelection={isCurrentSelection}>
      <AccommodationRoomTileImage roomPackage={roomOption.propertyRoom} showBookmark={false} />
      <AccommodationIndividualSelectRoomTileDetails roomPackage={roomOption.propertyRoom} />
      <AccommodationIndividualSelectRoomOptions hasOptions>
        {optionVariant === 'carousel' && (
          <CardCarousel width={carouselWidth} gutterSize={20} gap={12} snap="start">
            {noRateSelectionEnabled && sortedRates.length === 0 && noRateOption}
            {optionTiles}
          </CardCarousel>
        )}
        {optionVariant === 'stacked' && <>
          {noRateSelectionEnabled && sortedRates.length === 0 && noRateOption}
          {optionTiles}
        </>}
      </AccommodationIndividualSelectRoomOptions>
    </AccommodationIndividualSelectRoomTile>
  )
}

export default PropertyIndividualRoomSelectRoom
